<!--  -->
<template>
  <div v-loading="loading">
    <div class="boxlistTit">
      <el-select v-model="condition.status" placeholder="状态" style="width:130px;">
        <el-option :value="0" label="全部"></el-option>
        <el-option :value="1" label="未开始"></el-option>
        <el-option :value="2" label="授课中"></el-option>
        <el-option :value="3" label="已结课"></el-option>
      </el-select>
      <el-input v-model="condition.word" placeholder="授课班级名称、课程名称" style="width:300px;margin:0 10px"></el-input>
      <el-button type="primary" @click="search">查询</el-button>
      <router-link
        class="fr"
        :to="`/teacherManage`"
        style="margin-left:10px"
      >
        <el-button type="primary" size="small">返回</el-button>
      </router-link>
      <router-link
        class="fr"
        :to="`/alliance/teacher/${$route.query.schoolId}/courses/edit?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}`"
      >
        <el-button type="primary" size="small">新建</el-button>
      </router-link>
    </div>
    <el-table :data="courseList" style="width: 100%">
      <el-table-column prop="courseId" label="课程编号"></el-table-column>
      <el-table-column prop="courseName" label="授课班级名称"></el-table-column>
      <el-table-column prop="name" label="课程名称"></el-table-column>
      <el-table-column label="状态">
        <template slot-scope="{ row }">
          <span v-if="row.status == 1">未开始</span>
          <span v-if="row.status == 2">授课中</span>
          <span v-if="row.status == 3">已结课</span>
        </template>
      </el-table-column>
      <el-table-column prop="startDate" label="开课日期"></el-table-column>
      <el-table-column prop="endDate" label="结课日期"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{ row }">
          <div>
            <input type="file" ref="uploadFile" @change="onChange" style="display:none" />
            <el-button type="primary" size="small" @click="calendarSum(row)">课程表</el-button>
            <router-link
              style="margin:0 10px"
              :to="`/alliance/teacher/${$route.query.schoolId}/courses/edit?schoolId=${$route.query.schoolId}&teacherId=${$route.query.teacherId}&courseId=${row.courseId}`"
            >
              <el-button type="primary" size="small">编辑</el-button>
            </router-link>
            <el-button type="primary" size="small" @click="delCourse(row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="foot-pager"
      :page-size="10"
      :pager-count="11"
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="condition.startIndex"
      @current-change="search"
    ></el-pagination>
    <!-- 课程表设置 -->
    <el-dialog
      title="课程表设置"
      :visible.sync="calendarVisibles"
      top="4vh"
      width="1200px"
      :append-to-body="true"
      :modal-append-to-body="true"
      @opened="onUpdateDlgOpen"
    >
      <div>
        <span style="padding-right: 20px; font-size: 18px;">课程表</span>
        <!-- <el-button size="small">上传Excel批量设置</el-button>
        <el-button size="small">下载样例Excel文档</el-button>-->
        <el-button size="small" @click="download">下载样例Excel</el-button>
        <el-button size="small" type="primary" @click="downExcel">上传Excel批量设置</el-button>
        <el-button size="small" type="danger" @click="clearCourse">清空所有已添加</el-button>
      </div>
      <calendar :calendar="calendarParam" ref="updataCalendar"></calendar>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="calendarVisibles = false">取 消</el-button>
        <el-button type="primary" @click="calendarVisibles = false">确 定</el-button>
      </span>-->
    </el-dialog>
  </div>
</template>

<script>
import calendar from "../common/calendar";
import util from "@/assets/util/util.js";

export default {
  data() {
    return {
      files: null,
      calendarParam: {
        courseId: "",
        schoolId: "",
        teacherId: "",
      },
      calendarVisibles: false,
      total: 0,
      loading: false,
      columns: [
        {
          title: "课程编号",
          key: "courseId",
        },
        {
          title: "授课班级名称",
          key: "courseName",
        },
        {
          title: "课程名称",
          key: "name",
        },
        {
          title: "状态",
          key: "status",
        },
        {
          title: "开课日期",
          key: "startDate",
        },
        {
          title: "结课日期",
          key: "endDate",
        },
        {
          title: "操作",
          width: 350,
          slot: "action",
        },
      ],
      courseList: [],
      condition: {
        showItem: 10,
        schoolId: this.$route.query.schoolId,
        pageIndex: 1,
        status: 0,
        teacherId: this.$route.query.teacherId,
        word: "",
      },
    };
  },
  components: { calendar },
  methods: {
    // 课程表设置
    downExcel() {
      this.$refs.uploadFile.value = "";
      this.$refs.uploadFile.click();
    },
    // 课程表设置提交表单
    onChange() {
      this.files = this.$refs.uploadFile.files[0];
      let formData = new FormData();
      let file = this.$refs.uploadFile.files[0];
      formData.append("files", file);
      formData.append("courseId", this.calendarParam.courseId);
      formData.append("schoolId", this.$route.query.schoolId);
      formData.append("teacherId", this.$route.query.teacherId);
      const param = {
        courseId: this.calendarParam.courseId,
        schoolId: this.$route.query.schoolId,
        teacherId: this.$route.query.teacherId,
      };
      // formData.append("studentClassTO", JSON.stringify(this.form));
      this.$api.allianceSchool
        .uploadCourseSection(param, formData)
        .then((item) => {
          if (item.errCode == 0) {
            this.$refs.updataCalendar.initData(this.calendarParam);
          } else {
            this.$message.error(item.errMsg);
          }
        });
    },
    // 模板下载
    download() {
      this.$api.allianceSchool.courseMgrExcel().then((data) => {
        const blob = new Blob([data], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        util.export(blob, "导入课程表模板");
      });
    },
    // 删除
    delCourse(item) {
      this.$confirm("您确认删除吗？", "删除", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const params = {
          schoolId: this.$route.query.schoolId,
          courseId: item.courseId,
        };
        this.$api.allianceSchool.delCourse(params).then((res) => {
          if (res.errCode == 0) {
            this.condition.startIndex = 1;
            this.$message.success("删除成功！");
            this.search();
          } else {
            this.$message.error(res.errMsg);
          }
        });
      });
    },
    // 清空所有已添加clearCourseSection
    clearCourse() {
      this.$confirm("确认清空所有课程表设置？", "课程表设置", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.loading = true;
        this.$api.allianceSchool
          .clearCourseSection(this.calendarParam)
          .then((res) => {
            this.loading = false;
            if (res.errCode == 0) {
              this.$refs.updataCalendar.initData(this.calendarParam);
            } else {
              this.$message.error(res.errMsg);
            }
          })
          .catch((res) => {
            this.loading = false;
          });
      });
    },
    // 回调
    onUpdateDlgOpen() {
      this.$refs.updataCalendar.initData(this.calendarParam);
    },
    // 课程表
    calendarSum(row) {
      this.calendarParam.courseId = "";
      this.calendarVisibles = true;
      this.calendarParam.courseId = row.courseId;
      this.calendarParam.schoolId = this.$route.query.schoolId;
      this.calendarParam.teacherId = this.$route.query.teacherId;
    },
    // 搜索
    search() {
      this.loading = true;
      this.$api.allianceSchool
        .getCourseList(this.condition)
        .then((res) => {
          this.loading = false;
          if (res.errCode == 0) {
            this.courseList = res.data.items || [];
            this.total = res.data.totalItems;
          } else {
            this.$message.error(res.errMsg);
          }
        })
        .catch((res) => {
          this.loading = false;
        });
    },
  },
  created() {
    this.search();
  },
};
</script>
<style lang='less' scoped>
.boxlistTit {
  height: 100%;
}
.foot-pager {
  text-align: center;
}
</style>